// extracted by mini-css-extract-plugin
export default {"negative":"number_negative__OFaGv","positive":"number_positive__goVha","neutral":"number_neutral__if48O","opacity-transition":"number_opacity-transition__vT9Ma"};